import React from 'react';
import { Button } from '@headlessui/react';
import { FaPlus, FaQuestionCircle } from 'react-icons/fa';

const LandingPageHeader = ({ 
  canCreateLandingPage, 
  onCreate, 
  onShowVideo, 
  total 
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6">
      <h1 className="text-lg font-medium text-white">
        Landing Pages
      </h1>
      <div className="flex flex-row gap-2 sm:gap-3">
        <Button
          onClick={onShowVideo}
          className="group flex items-center justify-center px-3 sm:px-4 lg:px-6 py-2 sm:py-2 lg:py-3 rounded-lg lg:rounded-xl transition-all duration-200 data-hover:bg-gray-700 data-focus:ring-white border text-xs sm:text-sm lg:text-base bg-gray-800 text-white hover:bg-gray-700 border-gray-700"
        >
          <FaQuestionCircle className="mr-1 sm:mr-1 lg:mr-2 h-3 w-3 sm:h-3 sm:w-3 lg:h-4 lg:w-4 transition-transform duration-200 group-hover:scale-110" />
          <span className="hidden sm:inline lg:inline">How to Create?</span>
          <span className="sm:hidden lg:hidden">How to?</span>
        </Button>
        <Button
          onClick={onCreate}
          className={`group flex items-center justify-center px-3 sm:px-4 lg:px-6 py-2 sm:py-2 lg:py-3 rounded-lg lg:rounded-xl transition-all duration-200 data-hover:bg-gray-700 data-focus:ring-white border text-xs sm:text-sm lg:text-base ${
            canCreateLandingPage 
              ? 'bg-gray-800 text-white hover:bg-gray-700 border-gray-700' 
              : 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-700 hover:to-purple-700 border-indigo-500 animate-pulse'
          }`}
        >
          <FaPlus className={`mr-1 sm:mr-1 lg:mr-2 h-3 w-3 sm:h-3 sm:w-3 lg:h-4 lg:w-4 transition-transform duration-200 ${
            canCreateLandingPage ? 'group-hover:rotate-90' : 'animate-bounce'
          }`} />
          <span className="hidden sm:inline lg:inline">
            {canCreateLandingPage ? 'Create Landing Page' : 'Upgrade to Create More'}
          </span>
          <span className="sm:hidden lg:hidden">
            {canCreateLandingPage ? 'Create' : 'Upgrade'}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default LandingPageHeader;
